/* Copyright (c)2022 Sky Co., LTD. All rights reserved. */

export enum APP_TYPE {
    APP_TYPE_NONE = 0,      // なし、不明
    APP_TYPE_STORE = 1,     // AppStore
    APP_TYPE_VPP = 2,       // VPP
}

/// <summary>
/// アプリケーション情報のインターフェース
/// </summary>
/// <remarks>
/// ref: SCV\FrontEndEx\FrontEndEx\Controller\AppController.cs
/// </remarks>
export class AppInfo_ServerIF {
    // アプリ種別
    public appType = APP_TYPE.APP_TYPE_NONE;

    // iTunesStoreID
    public iTunesStoreID = 0;

    // アップデートが必要かどうか
    public hasUpdateAvailable = false;

    // インストール済みかどうか
    public isInstalled = false;

    // 設定ID
    public settingID = 0;

    // 説明
    public explanation = "";
}

/// <summary>
/// フォルダ情報
/// </summary>
export class FolderInfo {
    // フォルダーID
    catalogFolderID = 0;

    // 親のフォルダーID
    parentCatalogFolderID = 0;

    // フォルダ名
    catalogFolderName = "";

    // 表示順（オンプレのみ指定。M1は全て0が入っている）
    catalogFolderDisplayOrder = 0;

    // フォルダのデザイン
    catalogFolderDesign = 0;
}

/// <summary>
/// フォルダに含まれるアプリ情報
/// </summary>
export class FolderSetting {
    // フォルダーID
    catalogFolderID = 0;

    // アプリの設定ID
    settingID = new Array<number>();
}

export class Response_AppInfo_ServerIF {
    // アプリケーション一覧
    public appList = new Array<AppInfo_ServerIF>();

    // フォルダ情報
    public folderInfoList = new Array<FolderInfo>();

    // フォルダに含まれるアプリ情報
    public folderSettingList = new Array<FolderSetting>();
}


/* Copyright (c)2022 Sky Co., LTD. All rights reserved. */
